/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandheldScannerSettings = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19.5 15.145c.233.069.455.162.665.276l.81-.81 1.414 1.414-.81.81c.114.21.207.432.276.665H23v2h-1.145a3.44 3.44 0 0 1-.276.665l.81.81-1.414 1.414-.81-.81a3.44 3.44 0 0 1-.665.276V23h-2v-1.145a3.483 3.483 0 0 1-.665-.276l-.81.81-1.414-1.414.81-.81a3.483 3.483 0 0 1-.276-.665H14v-2h1.145a3.44 3.44 0 0 1 .276-.665l-.81-.81 1.414-1.414.81.81a3.44 3.44 0 0 1 .665-.276V14h2zM18.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
        <path d="M17.8 2A1.2 1.2 0 0 1 19 3.2v8.6a1.2 1.2 0 0 1-1.2 1.2H16v-2h1V4H5v7.018A1.2 1.2 0 0 1 6 12.2V20h7v2H5.2A1.2 1.2 0 0 1 4 20.8v-7.82c-.567-.095-1-.587-1-1.181V3.2A1.2 1.2 0 0 1 4.2 2z" />
        <path d="M9 19H7v-2h2zm3 0h-2v-2h2zm-3-3H7v-2h2zm3 0h-2v-2h2zm-3-3H7v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2zm-.2-8A1.2 1.2 0 0 1 16 6.2v2.6a1.2 1.2 0 0 1-1.2 1.2H7.2A1.2 1.2 0 0 1 6 8.8V6.2A1.2 1.2 0 0 1 7.2 5zM8 8h6V7H8z" />
      </g>
    </g>
  </Icon>
);
export { SvgHandheldScannerSettings as HandheldScannerSettings };
